export default "__VITE_ASSET__25483400__"